import { Component, OnInit, ElementRef, EventEmitter , CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { IItemConfigSet, IItemConfig, CategoryItemConfig } from "../../../interfaces/iitemconfig";
import { DropDownItem } from "../../../models/dropdown";
import { IDropDownView } from "../../../interfaces/idropdowns";

import { ItemConfigService } from "../../../services/itemconfig.service";
import { ActivatedRoute, Router, RouterModule } from "@angular/router";
import { ItemConfigHierachyService } from "../../../services/itemconfighierachy.service";
import { EmitterService } from "../../../services/emitter.service";
import { IButton } from "../../../interfaces/ibuttons";
import { DisableItemsFilterPipe } from "../../../pipes/disableitemsfilter.pipe";
import { ItemConfigListComponent } from "../itemconfiglist/itemconfiglist.component";

@Component({
    selector: "itemconfig",
    templateUrl: "./itemconfig.component.html",
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, ItemConfigListComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class ItemConfigComponent implements OnInit {
    configSet: IItemConfigSet;
    items: IItemConfig[];
    headerButtons: IButton[];
    selectedItem: IItemConfig;
    showDeleted: boolean = false;
    hideDisableItems: boolean = true;
    dropdownOptions: DropDownItem[] = new Array();
    constructor(private toastr: ToastrService,
        private activatedRoute: ActivatedRoute,
        private itemConfigService: ItemConfigService,
        private togglePipe: DisableItemsFilterPipe,
        private router: Router,
        private eref: ElementRef,
        private itemConfigHierachyService: ItemConfigHierachyService) {
    }

    ngOnInit(): void {
        this.configSet = this.activatedRoute.snapshot.data["configset"];
        let dropdowns: IDropDownView[] = this.activatedRoute.snapshot.data["dropdowns"];
        dropdowns.forEach((d: IDropDownView) => {
            this.dropdownOptions.push(<DropDownItem>{ id: d.id, text: d.label });
        });

        this.items = this.configSet.itemConfigs;

        let emitter: EventEmitter<any> = EmitterService.get("Create item");
        let button: IButton = { label: "Create item", btnClass: "fa fa-plus ml-2", btnClicked: emitter, disable: false };
        this.headerButtons = [button];
    }

    /**
     * Show or hide the disabled items from the screen.
     */
    showHideDisableItems(): void {
        this.showDeleted = !this.showDeleted;
        this.hideDisableItems = !this.hideDisableItems;
    }

    addItem(): void {
        if (this.items.find((i: IItemConfig) => { return i.name.trim().length === 0; })) {
            this.toastr.warning("Please complete the empty item before adding more sibling/child items.");

        } else {
            // add item based on type todo: this should be refactored into seperate components
            this.items.unshift(new CategoryItemConfig(
                "",
                null,
                false));
        }
    }

    onConfigItemDeleted(item: IItemConfig): void {
        this.items = this.items.filter(itm => itm !== item);
    }

    onItemsReordered(reorderedItems: IItemConfig[]): void {
        this.items = reorderedItems;
    }
}



